import { AxiosRequestConfig } from "axios";

import {
  ApiError,
  Audience,
  Insight,
  InsightMeta,
  InsightResult,
  PenPortrait,
} from "@/types";
import { fetchData } from "@/utils";

type GetInsightApiResponse = {
  data: { audience: Audience; insight: Insight };
  error: ApiError | null;
};

type GetMultipleInsightsApiResponse = {
  data: { audience: Audience; insight: Insight }[];
  error: ApiError | null;
};

export const getInsight = async (
  accessToken: string,
  audience_id: string,
  rebuild: boolean,
  client: string,
  segment?: boolean
): Promise<GetInsightApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/discover?audience_id=${audience_id}&rebuild=${rebuild}&client=${client}`;
   url = segment ? `${url}&segment=true` : `${url}&segment=false`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

export const getMultipleInsights = async (
  accessToken: string,
  audienceIds: string[],
  rebuild: boolean,
  client: string
): Promise<GetMultipleInsightsApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/discover/multiple?&client=${client}&rebuild=${rebuild}`;

  const data = {
    audience_ids: audienceIds,
  };

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    data,
  };

  return fetchData(config);
};

export const getDiscoverInsight = async (
  accessToken: string,
  mindset_id: string
): Promise<GetInsightApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/discover/mindsets?mindset_id=${mindset_id}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type UpdateMetaInsightResponse = {
  data: { audience_id: string; user_id: string; summary: InsightMeta[] };
  error: ApiError | null;
};

export const updateMeta = async (
  accessToken: string,
  audienceId: string,
  meta: InsightMeta[]
): Promise<UpdateMetaInsightResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/discover`;

  const data = {
    audience_id: audienceId,
    summary: meta,
  };

  const config: AxiosRequestConfig = {
    method: "PUT",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  };

  return fetchData(config);
};

type RefreshDescriptionResponse = {
  data: { description: string };
  error: ApiError | null;
};

export const refreshDescription = async (
  accessToken: string,
  audienceId: string,
  insight: InsightResult[],
  penPortrait: PenPortrait
): Promise<RefreshDescriptionResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/discover/describe`;

  const data = {
    audience_id: audienceId,
    insight: insight,
    pen_portrait: penPortrait.top_scores,
  };

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  };

  return fetchData(config);
};
